// extracted by mini-css-extract-plugin
export default {"iconButton":"iconSecondary_iconButton__3tZXCYO+"};